var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5428 1.59492C15.844 1.76286 15.9919 2.1146 15.9012 2.44733L13.9095 9.75H21.1776C21.4762 9.75 21.7464 9.92718 21.8655 10.2011C21.9845 10.475 21.9297 10.7934 21.7259 11.0117L11.2259 22.2617C10.9906 22.5139 10.6136 22.573 10.3124 22.4051C10.0112 22.2371 9.86328 21.8854 9.95403 21.5527L11.9457 14.25H4.6776C4.37895 14.25 4.10876 14.0728 3.98974 13.7989C3.87071 13.525 3.92553 13.2066 4.12931 12.9883L14.6293 1.73826C14.8646 1.48612 15.2416 1.42698 15.5428 1.59492Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintIcon);
export default __webpack_public_path__ + "static/media/mint_icon.b77c9ff6108c70820fd02e28395c4138.svg";
export { ForwardRef as ReactComponent };